import React, { useState } from 'react';
import { patientAPI } from '../../utils/api';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

function printPatientCard(p) {
    const win = window.open('', '_blank', 'width=400,height=600');
    win.document.write(`
        <html><head><title>Patient Card</title>
        <style>body{font-family:Arial,sans-serif;padding:24px;font-size:13px}
        h2{font-size:16px;margin-bottom:16px;border-bottom:2px solid #1e3a5f;padding-bottom:8px}
        .row{display:flex;justify-content:space-between;padding:5px 0;border-bottom:1px solid #f0f0f0}
        .label{color:#666;font-weight:600}.val{font-weight:700}
        .badge{background:#dc2626;color:#fff;padding:2px 8px;border-radius:4px;font-size:11px;font-weight:700}
        </style></head><body>
        <h2>Patient Card</h2>
        <div class="row"><span class="label">MRN</span><span class="val">${p.mrn}</span></div>
        <div class="row"><span class="label">Name</span><span class="val">${p.full_name}</span></div>
        <div class="row"><span class="label">Father Name</span><span class="val">${p.father_name || '—'}</span></div>
        <div class="row"><span class="label">Gender</span><span class="val">${p.gender}</span></div>
        <div class="row"><span class="label">Age</span><span class="val">${p.age_years ? `${p.age_years} years` : '—'}</span></div>
        <div class="row"><span class="label">CNIC</span><span class="val">${p.cnic || '—'}</span></div>
        <div class="row"><span class="label">Phone</span><span class="val">${p.phone || '—'}</span></div>
        <div class="row"><span class="label">Blood Group</span><span class="val">${p.blood_group ? `<span class="badge">${p.blood_group}</span>` : '—'}</span></div>
        ${p.allergies ? `<div class="row"><span class="label">Allergies</span><span class="val" style="color:#dc2626">${p.allergies}</span></div>` : ''}
        <div style="margin-top:24px;text-align:center;color:#999;font-size:11px">Printed: ${new Date().toLocaleString('en-PK')}</div>
        <script>window.onload=()=>window.print();</script>
        </body></html>
    `);
    win.document.close();
}

export default function PatientSearch() {
    const [q, setQ] = useState('');
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searched, setSearched] = useState(false);
    const navigate = useNavigate();

    const search = async (e) => {
        e.preventDefault();
        if (!q.trim()) return;
        setLoading(true);
        try {
            const res = await patientAPI.search(q);
            setResults(res.data.patients);
            setSearched(true);
        } catch {
            setResults([]);
            toast.error('Search failed. Check connection.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ padding: 24, backgroundColor: '#f8fafc', minHeight: '100vh' }}>
            <div style={{ marginBottom: 24 }}>
                <h1 style={{ fontSize: 24, fontWeight: 700, color: '#111827', margin: 0 }}>Patient Search</h1>
                <p style={{ fontSize: 14, color: '#6b7280', margin: '4px 0 0' }}>Search by name, MRN, CNIC, or phone number</p>
            </div>

            <form onSubmit={search} style={{ display: 'flex', gap: 12, marginBottom: 24 }}>
                <input
                    value={q}
                    onChange={(e) => setQ(e.target.value)}
                    placeholder="Search by Name, MRN, CNIC or Phone..."
                    style={{ flex: 1, padding: '12px 16px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, outline: 'none' }}
                />
                <button type="submit" style={{ padding: '12px 28px', background: '#1e3a5f', color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600, fontSize: 14 }}>
                    {loading ? 'Searching...' : 'Search'}
                </button>
                <button type="button" onClick={() => navigate('/patients/register')} style={{ padding: '12px 20px', background: '#16a34a', color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600, fontSize: 14 }}>
                    + Register New
                </button>
            </form>

            {searched && results.length === 0 && (
                <div style={{ textAlign: 'center', padding: 60, color: '#64748b', backgroundColor: '#fff', borderRadius: 12, border: '1px solid #e5e7eb' }}>
                    <div style={{ fontSize: 48, marginBottom: 12 }}>🔍</div>
                    <p style={{ fontSize: 16, marginBottom: 8 }}>No patients found for "<strong>{q}</strong>"</p>
                    <span style={{ color: '#1e3a5f', cursor: 'pointer', fontWeight: 600, fontSize: 14 }} onClick={() => navigate('/patients/register')}>
                        Register as new patient →
                    </span>
                </div>
            )}

            {results.length > 0 && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                    {results.map((p) => (
                        <div key={p.id} style={{ backgroundColor: '#fff', borderRadius: 12, border: '1px solid #e5e7eb', padding: '16px 20px', display: 'flex', alignItems: 'center', gap: 20 }}>
                            {/* Patient info */}
                            <div style={{ flex: 1 }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
                                    <span style={{ fontSize: 16, fontWeight: 700, color: '#111827' }}>{p.full_name}</span>
                                    {p.blood_group && (
                                        <span style={{ background: '#dc2626', color: '#fff', padding: '2px 8px', borderRadius: 4, fontSize: 11, fontWeight: 700 }}>{p.blood_group}</span>
                                    )}
                                    {p.allergies && (
                                        <span style={{ background: '#fef2f2', color: '#dc2626', padding: '2px 8px', borderRadius: 4, fontSize: 11, fontWeight: 600, border: '1px solid #fecaca' }}>
                                            ⚠ Allergies
                                        </span>
                                    )}
                                </div>
                                <div style={{ display: 'flex', gap: 16, fontSize: 13, color: '#6b7280', flexWrap: 'wrap' }}>
                                    <span style={{ fontWeight: 600, color: '#1e3a5f' }}>MRN: {p.mrn}</span>
                                    <span>{p.gender}</span>
                                    <span>{p.age_years ? `${p.age_years} yrs` : '—'}</span>
                                    {p.cnic && <span>CNIC: {p.cnic}</span>}
                                    {p.phone && <span>📞 {p.phone}</span>}
                                    {p.father_name && <span>S/O D/O W/O: {p.father_name}</span>}
                                </div>
                                {p.allergies && (
                                    <div style={{ marginTop: 6, fontSize: 12, color: '#dc2626', fontWeight: 600 }}>
                                        Allergies: {p.allergies}
                                    </div>
                                )}
                            </div>

                            {/* Quick actions */}
                            <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
                                <button
                                    onClick={() => navigate(`/opd/register?patient_id=${p.id}`)}
                                    style={{ padding: '8px 14px', background: '#2563eb', color: '#fff', border: 'none', borderRadius: 7, cursor: 'pointer', fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap' }}
                                >
                                    New OPD Visit
                                </button>
                                <button
                                    onClick={() => navigate(`/opd/patient/${p.id}/history`)}
                                    style={{ padding: '8px 14px', background: '#7c3aed', color: '#fff', border: 'none', borderRadius: 7, cursor: 'pointer', fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap' }}
                                >
                                    History 360°
                                </button>
                                <button
                                    onClick={() => navigate(`/patients/${p.id}`)}
                                    style={{ padding: '8px 14px', background: '#1e3a5f', color: '#fff', border: 'none', borderRadius: 7, cursor: 'pointer', fontSize: 12, fontWeight: 600 }}
                                >
                                    View
                                </button>
                                <button
                                    onClick={() => printPatientCard(p)}
                                    style={{ padding: '8px 12px', background: '#fff', color: '#374151', border: '1px solid #d1d5db', borderRadius: 7, cursor: 'pointer', fontSize: 12, fontWeight: 600 }}
                                >
                                    Print
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
